import { render } from "./UserRecords.vue?vue&type=template&id=3e0adac3&scoped=true"
import script from "./UserRecords.vue?vue&type=script&lang=js"
export * from "./UserRecords.vue?vue&type=script&lang=js"

import "./UserRecords.vue?vue&type=style&index=0&id=3e0adac3&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0adac3"]])

export default __exports__